export default {_name:'checkbox',module:'Field',view:'Element/Field/Check',options:{xs:12},mobileOptions:{ms:12}}